export const es_todo= {
    title: 'To Do',
    list_title: 'Tuya Lista Tareas',
    label_description: 'Que hacer',
    question_title: 'Confirmar cancelación',
    question: '¿Estás seguro de que quieres borrar esta Lista?',
    label_scadenza:'Caducidad',
    label_assegna:'Asignar a:',
    label_aggiungi:'Agregar',

        'popover_todo_title': 'Lista Tareas',
    'popover_todo_content' : '<p>Introduce las actividades a realizar y compártelas con tu equipo.                  </p>\n'

};